// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Eskh","choiceBoxes":"toolbarselects_choiceBoxes__2zmGE","simpleField":"toolbarselects_simpleField__16ufm"};